import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=4faf3211&"
import script from "./header-menu.vue?vue&type=script&lang=js&"
export * from "./header-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports